import { render, staticRenderFns } from "./best-trend-modal.component.vue?vue&type=template&id=a60008b4&scoped=true"
import script from "./best-trend-modal.component.vue?vue&type=script&lang=js"
export * from "./best-trend-modal.component.vue?vue&type=script&lang=js"
import style0 from "./best-trend-modal.component.vue?vue&type=style&index=0&id=a60008b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60008b4",
  null
  
)

export default component.exports